import { useLazyTenjinUploadUrl } from 'src/models/biddingGPT/hooks';
import { useTranslation } from 'react-i18next';
import React, { FC, useCallback } from 'react';
import { RcFile } from 'antd/lib/upload';
import Button from 'src/common/Button';
import { Upload } from 'src/common';
import styles from './index.module.scss';

export const UploadBiddingGPTFile: FC = () => {
  const { t } = useTranslation();
  const [getFileLazy, { loading }] = useLazyTenjinUploadUrl();

  const onUpload = useCallback(
    async (file: RcFile) => {
      const data = await getFileLazy({ variables: { targetPath: file.name } });

      if (data?.data?.getSignedUrlUploadTenjin && file) {
        await fetch(data?.data?.getSignedUrlUploadTenjin, {
          method: 'put',
          body: file
        });
      }
      return Upload.LIST_IGNORE;
    },
    [getFileLazy]
  );

  return (
    <Upload name={'file'} showUploadList={false} method={undefined} beforeUpload={onUpload}>
      <Button type={'primary'} loading={loading} className={styles.upload}>
        {t('Common.uploadFile')}
      </Button>
    </Upload>
  );
};

export default UploadBiddingGPTFile;
